(function () {
    'use strict';

    var selector = [
        'select.bb-select',
        'select.bb-standard-select',
        'select[data-bb-select-menu]'
    ].join(',');
    var instances = new WeakMap();
    var activeInstance = null;
    var id = 0;

    function isEspresso() {
        return document.body && document.body.getAttribute('data-bb-skin') === 'espresso';
    }

    function isEligible(select) {
        return select.matches(selector) &&
            !select.multiple &&
            Number(select.size || 0) <= 1 &&
            !select.hasAttribute('data-bb-native-popup') &&
            !select.closest('.form-studio-preview');
    }

    function optionLabel(option) {
        return (option.label || option.textContent || '').trim();
    }

    function closeActive(focusTrigger) {
        if (!activeInstance) return;
        activeInstance.close(Boolean(focusTrigger));
    }

    function create(select) {
        if (!isEligible(select) || instances.has(select)) return;

        var root = document.createElement('div');
        var trigger = document.createElement('button');
        var value = document.createElement('span');
        var list = document.createElement('div');
        var listId = 'bb-native-select-list-' + (++id);

        root.className = 'bb-native-select-menu';
        trigger.type = 'button';
        trigger.className = 'bb-native-select-menu__trigger';
        trigger.setAttribute('role', 'combobox');
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', listId);
        var selectLabel = select.getAttribute('aria-label');
        if (!selectLabel && select.labels && select.labels.length) {
            selectLabel = (select.labels[0].textContent || '').trim();
        }
        if (selectLabel) trigger.setAttribute('aria-label', selectLabel);
        if (select.hasAttribute('aria-describedby')) {
            trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
        }
        value.className = 'bb-native-select-menu__value';
        list.className = 'bb-native-select-menu__list';
        list.id = listId;
        list.setAttribute('role', 'listbox');
        list.setAttribute('tabindex', '-1');
        list.hidden = true;
        trigger.appendChild(value);
        root.appendChild(trigger);
        root.appendChild(list);
        select.insertAdjacentElement('afterend', root);
        select.classList.add('bb-native-select-menu__native');

        var instance = {
            select: select,
            root: root,
            trigger: trigger,
            value: value,
            list: list,
            optionButtons: [],
            originalTabIndex: select.getAttribute('tabindex'),

            syncMode: function () {
                var enabled = isEspresso();
                root.hidden = !enabled;
                if (enabled) {
                    select.setAttribute('tabindex', '-1');
                    select.setAttribute('aria-hidden', 'true');
                } else {
                    this.close(false);
                    select.removeAttribute('aria-hidden');
                    if (this.originalTabIndex === null) select.removeAttribute('tabindex');
                    else select.setAttribute('tabindex', this.originalTabIndex);
                }
            },

            render: function () {
                var fragment = document.createDocumentFragment();
                this.optionButtons = [];
                Array.prototype.forEach.call(select.children, function (child) {
                    if (child.tagName === 'OPTGROUP') {
                        var group = document.createElement('div');
                        group.className = 'bb-native-select-menu__group';
                        group.textContent = child.label;
                        fragment.appendChild(group);
                        Array.prototype.forEach.call(child.children, appendOption);
                    } else if (child.tagName === 'OPTION') {
                        appendOption(child);
                    }
                });

                function appendOption(option) {
                    var button = document.createElement('button');
                    button.type = 'button';
                    button.className = 'bb-native-select-menu__option';
                    button.setAttribute('role', 'option');
                    button.textContent = optionLabel(option);
                    button.disabled = option.disabled || select.disabled;
                    button.dataset.optionIndex = String(option.index);
                    fragment.appendChild(button);
                    instance.optionButtons.push(button);
                }

                list.replaceChildren(fragment);
                this.sync();
            },

            sync: function () {
                var selected = select.options[select.selectedIndex];
                value.textContent = selected ? optionLabel(selected) : '';
                trigger.disabled = select.disabled;
                trigger.setAttribute('aria-disabled', select.disabled ? 'true' : 'false');
                this.optionButtons.forEach(function (button) {
                    var selectedOption = Number(button.dataset.optionIndex) === select.selectedIndex;
                    button.classList.toggle('is-selected', selectedOption);
                    button.setAttribute('aria-selected', selectedOption ? 'true' : 'false');
                });
            },

            open: function (direction) {
                if (!isEspresso() || select.disabled) return;
                if (activeInstance && activeInstance !== this) activeInstance.close(false);
                this.render();
                list.hidden = false;
                root.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
                activeInstance = this;

                var rect = trigger.getBoundingClientRect();
                var roomBelow = window.innerHeight - rect.bottom;
                var roomAbove = rect.top;
                root.classList.toggle('opens-up', roomBelow < 260 && roomAbove > roomBelow);

                var selectedButton = this.optionButtons.find(function (button) {
                    return button.classList.contains('is-selected') && !button.disabled;
                });
                var firstEnabled = this.optionButtons.find(function (button) { return !button.disabled; });
                var target = selectedButton || firstEnabled;
                if (direction === 'last') {
                    target = this.optionButtons.slice().reverse().find(function (button) { return !button.disabled; }) || target;
                }
                window.requestAnimationFrame(function () {
                    if (target) {
                        target.focus();
                        target.scrollIntoView({ block: 'nearest' });
                    }
                });
            },

            close: function (focusTrigger) {
                list.hidden = true;
                root.classList.remove('is-open', 'opens-up');
                trigger.setAttribute('aria-expanded', 'false');
                if (activeInstance === this) activeInstance = null;
                if (focusTrigger && isEspresso()) trigger.focus();
            },

            choose: function (button) {
                if (!button || button.disabled) return;
                var nextIndex = Number(button.dataset.optionIndex);
                if (select.selectedIndex !== nextIndex) {
                    select.selectedIndex = nextIndex;
                    select.dispatchEvent(new Event('input', { bubbles: true }));
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
                this.sync();
                this.close(true);
            }
        };

        trigger.addEventListener('click', function () {
            if (root.classList.contains('is-open')) instance.close(false);
            else instance.open();
        });

        trigger.addEventListener('keydown', function (event) {
            if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].indexOf(event.key) === -1) return;
            event.preventDefault();
            instance.open(event.key === 'ArrowUp' || event.key === 'End' ? 'last' : 'first');
        });

        list.addEventListener('click', function (event) {
            instance.choose(event.target.closest('.bb-native-select-menu__option'));
        });

        list.addEventListener('keydown', function (event) {
            var enabled = instance.optionButtons.filter(function (button) { return !button.disabled; });
            var current = enabled.indexOf(document.activeElement);
            var next = current;
            if (event.key === 'ArrowDown') next = Math.min(current + 1, enabled.length - 1);
            else if (event.key === 'ArrowUp') next = Math.max(current - 1, 0);
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = enabled.length - 1;
            else if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                instance.choose(document.activeElement);
                return;
            } else if (event.key === 'Escape') {
                event.preventDefault();
                instance.close(true);
                return;
            } else return;
            event.preventDefault();
            if (enabled[next]) enabled[next].focus();
        });

        root.addEventListener('focusout', function (event) {
            if (!root.contains(event.relatedTarget)) instance.close(false);
        });
        select.addEventListener('change', function () { instance.sync(); });
        if (select.form) {
            select.form.addEventListener('reset', function () {
                window.requestAnimationFrame(function () { instance.sync(); });
            });
        }

        instances.set(select, instance);
        instance.render();
        instance.syncMode();
    }

    function scan(root) {
        if (!root || root.nodeType !== 1) return;
        if (root.matches && root.matches(selector)) create(root);
        if (root.querySelectorAll) root.querySelectorAll(selector).forEach(create);
    }

    function syncAll() {
        document.querySelectorAll(selector).forEach(function (select) {
            create(select);
            var instance = instances.get(select);
            if (instance) {
                instance.syncMode();
                instance.render();
            }
        });
    }

    function boot() {
        scan(document.body);
        document.addEventListener('click', function (event) {
            if (activeInstance && !activeInstance.root.contains(event.target)) closeActive(false);
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') closeActive(true);
        });
        document.addEventListener('click', function (event) {
            var label = event.target.closest('label[for]');
            if (!label || !isEspresso()) return;
            var select = document.getElementById(label.htmlFor);
            var instance = select && instances.get(select);
            if (instance) {
                event.preventDefault();
                instance.trigger.focus();
            }
        });

        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.target === document.body) syncAll();
                mutation.addedNodes.forEach(scan);
                var changedSelect = mutation.target && mutation.target.closest ? mutation.target.closest(selector) : null;
                if (changedSelect) {
                    var instance = instances.get(changedSelect);
                    if (instance) instance.render();
                }
            });
        }).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-bb-skin', 'disabled']
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
}());
